import { http } from "@/lib/http";
import { isMockEnabled } from "@/lib/mock-flags";
import type { StoredNotification } from "../types";
import * as mock from "../mocks/fixtures";

/** Página de notificações paginada por cursor (espelha CursorPage<T> do agency-api). */
export interface NotificationPage {
  items: StoredNotification[];
  nextCursor: string | null;
}

/**
 * Histórico persistido das notificações (newest-first) por cursor/keyset.
 * Passe `nextCursor` da página anterior para carregar a próxima (null = fim).
 * O tempo real continua vindo do stream SSE — esta é a base histórica.
 */
export const listNotifications = async (
  cursor?: string | null,
  limit = 20,
): Promise<NotificationPage> => {
  if (isMockEnabled("notifications")) return mock.listNotifications(cursor, limit);
  const { data } = await http.get<NotificationPage>("/notifications", {
    params: { cursor: cursor ?? undefined, limit },
  });
  return data;
};

/** Marca uma notificação como lida (persiste). */
export const markNotificationRead = async (id: string): Promise<void> => {
  if (isMockEnabled("notifications")) return mock.markRead(id);
  await http.post(`/notifications/${id}/read`);
};

/** Marca todas as notificações da organização como lidas (persiste). */
export const markAllNotificationsRead = async (): Promise<void> => {
  if (isMockEnabled("notifications")) return mock.markAllRead();
  await http.post("/notifications/read-all");
};
